import React from 'react';
import classNames from 'classnames/bind';

import { IContinent } from '../types';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface ContinentProps {
  continent: IContinent;
  forDeparture: boolean;
  markMatchedSubstrings(target: string): { __html: string };
}

const Continent: React.FC<ContinentProps> = ({
  continent,
  forDeparture,
  markMatchedSubstrings,
}) => {
  const { continentName, type } = continent;

  const handleClick = () => {
    location.href = `/flights/everywhere/monthly/SEL?continents=${continent.continentId}`;
  };

  return (
    <li className={cx('list_item')}>
      <a
        className={cx('anchor')}
        onClick={handleClick}
        data-event-nlog="click"
        data-event-area-code={`${forDeparture ? 'dep' : 'arr'}.autocontinent`}
      >
        <i className={cx('icon')} data-type={type.toUpperCase()} />
        <b className={cx('name')}>
          <span
            className={cx('name_inner')}
            dangerouslySetInnerHTML={markMatchedSubstrings(continentName)}
          />
        </b>
        <div className={cx('desc')}>모든 도시 및 공항</div>
      </a>
    </li>
  );
};

export default Continent;
